export default __webpack_public_path__ + "static/media/fairs.77f5cd58.jpg";